angular.module('impactx.util').directive('ixDefaultImage', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            attrs.$set('src', attrs.ixDefaultImage);
            element.bind('error', function() {
                if (attrs.src !== attrs.ixDefaultImage) {
                    attrs.$set('src', attrs.ixDefaultImage);
                }
            });
        }
    }
});